<template>
  <div>
    <home-header />
    <div class="content page-width">
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-md-2">
          <div class="personalimg">
            <img
              :src="userInfo.avatar ? userInfo.avatar : userInfo.sex === '1' ? `https://stu8.jxjypt.cn/nan.jpg` : `https://stu8.jxjypt.cn/nv.jpg`"
              width="94"
              height="94"
            />
          </div>
          <h1>
            {{ userInfo.name }}
            <span class="grade">({{ userInfo.grade }})</span>
          </h1>
          <div class="margin-bottom-20 mymajor">专业：{{ userInfo.proName }}</div>
          <div class="margin-bottom-20 mymajor">登录次数：{{ userInfo.loginCount }}</div>
          <div class="margin-bottom-20 enroll-switch" v-if="showSwitchBtn">
            <a-button type="link" size="small" @click="openSwitchModal">
              <a-icon type="sync" />
              <span>切换学籍</span>
            </a-button>
          </div>
          <ul class="centerli">
            <li class="centerli-top">个人中心</li>
            <li><router-link to="/personalcenters/myinfo" active-class="active" exact>我的信息</router-link></li>
            <li v-if="$store.state.homeObj.archive_change_show != '0'">
              <router-link to="/personalcenters/changestate" active-class="active">学籍异动申请表</router-link>
            </li>
            <li v-if="$store.state.homeObj.exam_post != '0'">
              <router-link to="/personalcenters/examPost" active-class="active">缓考申请</router-link>
            </li>
            <li v-if="$store.state.homeObj.doc_info_collection_show === '1'">
              <router-link to="/personalcenters/infocollect" active-class="active">信息采集</router-link>
            </li>
            <li v-if="$store.state.homeObj.unpaidTuitionFlag !== '0'">
              <router-link to="/mypersonal/tuitionfeethis" active-class="active">我的学费</router-link>
            </li>
            <li v-if="$store.state.homeObj.show_fee === '1'">
              <router-link to="/personalcenters/payment" active-class="active">{{ homeObj.edu_fee_name }}</router-link>
            </li>
            <li v-if="$store.state.homeObj.exam_mode === '2'">
              <router-link to="/personalcenters/applyOfflineExam" active-class="active" exact>预约线下考试</router-link>
            </li>
            <li v-if="$store.state.homeObj.feedBack_show === '1'">
              <router-link to="/personalcenters/FeedBack" active-class="active">意见反馈</router-link>
            </li>
            <li v-if="$store.state.homeObj.photo_show === '1'">
              <router-link to="/personalcenters/getStuPhoto" active-class="active">毕业生照片采集</router-link>
            </li>
            <li v-if="$store.state.homeObj.gra_apply_enable != '0'">
              <router-link to="/graduation/apply" active-class="active">毕业或学位申请</router-link>
            </li>
            <li v-if="$store.state.homeObj.storage_show === '1'">
              <router-link to="/personalcenters/fileStorage" active-class="active">个人云盘</router-link>
            </li>
            <li><router-link to="/personalcenters/forgetpassword" active-class="active">修改密码</router-link></li>
            <li><router-link to="/personalcenters/SecuritySetting" active-class="active">安全中心</router-link></li>
          </ul>
        </div>
        <div class="col-md-10">
          <router-view />
        </div>
      </div>
      <ul>
        <li></li>
      </ul>
    </div>
    <Foot></Foot>

    <!-- 学籍切换子组件 -->
    <EnrollmentSwitch :visible.sync="switchModalVisible" :curStuId="userInfo.id" />
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header';
import InsidePageBannar from '@/common/components/InsidePageBannar';
import InsidePageLeft from '@/common/components/InsidePageLeft';
import Foot from '@/common/components/Foot';
import Fade from '@/common/fade/FadeAnimation';
import MajorList from './components/MajorList';
import SecuritySetting from './components/SecuritySetting';
import EnrollmentSwitch from '@/common/components/EnrollmentSwitch.vue';
import axios from 'axios';
import { mapState } from 'vuex';

export default {
  name: 'PersonalCenters',
  components: {
    HomeHeader,
    InsidePageBannar,
    Foot,
    MajorList,
    InsidePageLeft,
    Fade,
    SecuritySetting,
    EnrollmentSwitch,
  },
  data: function() {
    return {
      arrs: [],
      sex: true,
      showSwitchBtn: false, // 是否展示切换学籍按钮
      switchModalVisible: false, // 学籍切换组件展示状态
    };
  },
  methods: {
    /**
     * 检查学生是否存在多学籍情况
     */
    checkEnrollmentCount() {
      this.axios
        .get('/biz/archive/getEnrollmentList')
        .then(res => {
          if (res.success && res.result && res.result.length > 1) {
            this.showSwitchBtn = true;
          } else {
            this.showSwitchBtn = false;
          }
        })
        .catch(() => {
          this.showSwitchBtn = false;
        });
    },

    /**
     * 显示多学籍切换弹框
     */
    openSwitchModal() {
      this.switchModalVisible = true;
    },

    handleGetDataSucc(res) {
      res = res.data;
      if (res.ret && res.data) {
        const data = res.data;
        this.arrs = data.course;
      }
    },
  },
  mounted() {
    this.checkEnrollmentCount();
  },
  computed: {
    ...mapState(['userInfo', 'homeObj']),
  },
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl'
.page-width{
  width:$pageWidth;
  margin:0 auto;
}
.content{
  margin-top:30px;
  background:#fff;
  padding:28px;
  margin-bottom:30px;
  min-height:500px;
  .col-md-2{
    min-height:500px;
    border-right:3px solid #edeff5;
    text-align:center;
    .active{
      background:$bgColor;
      color:#fff;
    }

  }
}
.centerli{
  background:$bgcontent;
  border-radius:10px;
  padding-bottom:30px;
  overflow:hidden;
  padding-top:20px;
  .centerli-top{
    padding:15px 0;
    font-size:18px;
    color:$bgColor;
    font-weight:bold;
  }
  li{
    margin:0px 10px;
    a{
      display:inline-block;
      width:100%;
      padding:15px 0;
      border-bottom:1px solid  #eaeaea;
      color:#999;

    }
  }
}
h1{
  font-size:24px;
  margin-bottom:10px;
  margin-top:20px;
  .grade{
    font-size:15px;
    margin-left:15px;
    color:#666;
  }
}
.personalimg{
  img{
    width:112px;
    height:125px;
  }
}
.mymajor{
  color:#999;
  margin-bottom:14px;
}

.enroll-switch {
  font-size: 14px;
  background-color: #f2f3f5;
  border-radius: 20px;
  padding: 4px 12px;
  display: inline-flex;
  align-items: center;
  height: 30px;

  .ant-btn-link {
    display: inline-flex;
    align-items: center;
    padding: 0;
    height: auto;

    .anticon {
      display: inline-flex;
      align-items: center;
      margin-right: -4px; // 图标与文字间距，可调整
      font-size: 14px;
    }
    span {
      line-height: 1;
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/Index.vue